import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { object, string, array, InferType } from "yup";

export const DropPropertySchema = object({
  reason: string()
    .default("")
    .required("Indique una razón")
    .meta({ label: "Razón" }),
  businessDays: array()
    .of(
      object({
        label: string().default(""),
        value: string().default("")
      })
    )
    .min(1, "Indique la cantidad de días de baja")
    .default([{ label: "60 días ", value: "60" }])
    .meta({ label: "Días" }),
  otherReason: string()
    .default("")
    .when("reason", {
      is: (reason: string) => {
        return reason === "6" || reason === "5";
      },
      then: schema => schema.required("Describa la razón"),
      otherwise: schema => schema
    })
    .meta({ label: "Otra razón" })
});

export type IDropPropertySchema = InferType<typeof DropPropertySchema>;
export const CDropProperty = DropPropertySchema.getDefault();
export const CDropPropertyKeys = HGetKeyEnums(CDropProperty) as {
  [K in keyof typeof CDropProperty]: K;
};
